module.exports = new __parcel__URL__("EMIT_AVIRIS3_Data_Insight_Banner_v2.5bfb21a2.jpg").toString();